
export const initialValues = {
  categoryCode: "",
  categoryShortCode: "",
  categoryName: "",
  brandId: "",
  activeStatus: 1,
}